import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-md-none d-block" }
const _hoisted_2 = { class: "col-12 d-flex flex-row nowrap justify-content-between mb-4" }
const _hoisted_3 = { class: "heading text-start text-grey-900" }
const _hoisted_4 = { class: "inner-wrapper bg-white shadow-3 position-relative" }
const _hoisted_5 = {
  key: 0,
  class: "caption-strong text-primary-blue mb-1 mt-1"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "d-flex align-items-center gap-2 justify-content-between" }
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = { class: "text-primary me-2" }
const _hoisted_10 = {
  width: "20",
  height: "20",
  class: "icon text-primary-blue"
}
const _hoisted_11 = ["xlink:href"]
const _hoisted_12 = { class: "caption-strong text-grey-900" }
const _hoisted_13 = { class: "subcaption text-grey-700" }
const _hoisted_14 = {
  key: 0,
  class: "btn-close-sm ms-2"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "d-flex align-items-center gap-2 justify-content-between" }
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "caption-strong text-grey-900" }
const _hoisted_19 = { class: "subcaption text-grey-700" }
const _hoisted_20 = {
  key: 0,
  class: "btn-close-sm ms-2"
}
const _hoisted_21 = {
  key: 0,
  class: "px-3"
}
const _hoisted_22 = { class: "form-check mt-4 position-sticky bottom-0 bg-white shadow-3 d-flex gap-2 m-0 ps-5 py-3" }
const _hoisted_23 = {
  class: "form-check-label",
  for: "noTransport"
}
const _hoisted_24 = { class: "d-flex justify-content-end mt-3 px-3 d-md-none" }
const _hoisted_25 = ["disabled"]

import { ref, computed, watch, nextTick } from "vue"
import { useStore } from "vuex"
import { airportCodeMap } from "@/config/airportCodeMap"
import { trainStationCodeMap } from "@/config/trainStationCodeMap"
import { transportPacks } from "@/config/transportPackagePriorities"
import DropdownInput from "./dropdownInput.vue"
import ClsBtn from '@/vue/common/clsBtn.vue'
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes"
import screenType from "@/vue/planning/computed/screenType"
import NoResultsSearch from "./NoResultsSearch.vue"

interface FlightOriginGroup {
	name: string
	codes: string[]
	key: string
	type: "train" | "flight"
	showTitle: boolean
	children?: FlightOriginGroup[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'flightOriginDropDown',
  setup(__props) {

const store = useStore()

const dropdownOpen = ref(false)
const checked = ref(false)
const selectedCode = ref<string>(store.state.flightOrigin)
const searchQuery = ref("")
const filteredFlightOrigins = ref<FlightOriginGroup[]>([])

// Template ref to access the DropdownInput component
const dropdownInputRef = ref<InstanceType<typeof DropdownInput> | null>(null)

const content = computed(() => store.state.content)
const disabled = computed(() => !transportPacks.includes(store.state.packCode))

const groupedTransportOrigins = computed<FlightOriginGroup[]>(() => {
	const allCodes = [...new Set(store.getters.flightOrigins)] as string[]
	const groups: FlightOriginGroup[] = []
	const seenCodes = new Set<string>()
	const titleFlags = { train: false, flight: false }

	

	// Add train stations
	if (availableTransportPackCodes.value.length) {
		const trainGroups = Array.from(trainStationCodeMap.entries()).map(([code, info]) => ({
			name: store.state.content[`planning_traintimeline_station_${code}`],//info.name,
			codes: [code],
			key: code,
			type: "train",
			showTitle: !titleFlags.train && (titleFlags.train = true)
		})) as FlightOriginGroup[]
		groups.push(...trainGroups)
	}

	// Add remaining airports
	for (const code of allCodes) {
		if (seenCodes.has(code)) continue

		const currentCodeInfo = airportCodeMap.get(code);

		// const name = currentCodeInfo?.name || "";
		const name = store.state.content[`planning_airport_${code}`] || "";

		const relatedCodes = allCodes.filter(c => airportCodeMap.get(c)?.parent === code && !seenCodes.has(c))
		relatedCodes.forEach(c => seenCodes.add(c))

		if (!currentCodeInfo?.parent) {
			groups.push({
				name,
				codes: [code],//relatedCodes,
				key: code,//relatedCodes.join("-"),
				type: "flight",
				showTitle: !titleFlags.flight && (titleFlags.flight = true),
				children: relatedCodes.map(c => ({
					name: airportCodeMap.get(c)?.name || "",
					codes: [c],
					key: c,
					type: "flight",
					showTitle: false
				})),
			})
		}
	}

	return groups
})

function getOriginLabel(selectedOrigin: string): string {
	const found = groupedTransportOrigins.value.find(group => group.key === selectedOrigin)
	if (found) return found.name

	const origin = selectedOrigin?.split("-")[0] || ""
	const originLabel = airportCodeMap.get(origin)?.name || store.state.content[`planning_traintimeline_station_${origin}`] || ""
	return originLabel
}

// ✅ FIXED FUNCTION: strict equality match
function isSelected(code: string): boolean {
	return selectedCode.value === code
}

function handleSelect(code: string) {
	if (isSelected(code)) {
		handleUnselect()
		return
	}
	selectedCode.value = code
	if (window.innerWidth >= 1024) {
		store.commit("setFlightOrigin", code)
		//store.dispatch("setDefaultPackageForOriginType", code)
		closeDropdown()
	}
	handleSearch("")
}

function handleUnselect() {
	selectedCode.value = ""
	handleSearch("")
	store.commit("setFlightOrigin", airportCodeMap.get("None")?.name)
}

function handleConfirm() {
	if (selectedCode.value) {
		store.commit("setFlightOrigin", selectedCode.value)
		// store.dispatch("setDefaultPackageForOriginType", selectedCode.value)
		closeDropdown()
	}
}

function handleSearch(query: string) {
	searchQuery.value = query.toLowerCase()
	if (!query) {
		filteredFlightOrigins.value = groupedTransportOrigins.value
		return
	}

	filteredFlightOrigins.value = groupedTransportOrigins.value
		.map(group => {
			const matchGroup = group.name.toLowerCase().includes(searchQuery.value)
			const matchChildren = group.children?.filter(child =>
				child.name.toLowerCase().includes(searchQuery.value) ||
				child.codes.some(code => code.toLowerCase().includes(searchQuery.value))
			)

			if (matchGroup || (matchChildren && matchChildren.length)) {
				return {
					...group,
					children: matchChildren?.length ? matchChildren : group.children
				}
			}
			return null
		})
		.filter(Boolean) as FlightOriginGroup[]
}

function openDropdown() {
	dropdownOpen.value = true
}

function closeDropdown() {
	dropdownOpen.value = false
	selectedCode.value = store.state.flightOrigin || ''
	document.body.classList.remove("overflow-hidden")
}

async function focusInput() {
	await nextTick()
	if (dropdownInputRef.value?.inputRef) {
		dropdownInputRef.value.inputRef.focus()
	}
}

// Watchers
watch(dropdownOpen, async (val) => {
	if (val) {
		filteredFlightOrigins.value = groupedTransportOrigins.value
		// Auto-focus on mobile when dropdown opens
		if (screenType.value === "mobile") {
			await focusInput()
		}
	}
})
watch(checked, val => {
	store.commit("setTransportTrue", !val)
	store.dispatch("selectTransportWithDefaultPackage", !val)
	closeDropdown()
})
watch(() => store.state.transportationSelected, val => {
	checked.value = !val
	
})
watch(() => store.state.flightOrigin, val => {
	selectedCode.value = val
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["col", { 'd-none': disabled.value }])
  }, [
    _createVNode(DropdownInput, {
      label: content.value.flight_leaving_from,
      placeholder: content.value.flight_station_or_airport,
      value: getOriginLabel(selectedCode.value),
      dropdownOpen: dropdownOpen.value,
      onClose: closeDropdown,
      onOpen: openDropdown,
      onSearch: handleSearch,
      disabled: disabled.value
    }, {
      dropdown: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(content.value.flight_leaving_from), 1),
            _createVNode(ClsBtn, { onClick: closeDropdown })
          ]),
          _createVNode(DropdownInput, {
            ref_key: "dropdownInputRef",
            ref: dropdownInputRef,
            label: content.value.flight_leaving_from,
            placeholder: content.value.flight_station_or_airport,
            value: getOriginLabel(selectedCode.value),
            dropdownOpen: false,
            onClose: closeDropdown,
            onOpen: openDropdown,
            onSearch: handleSearch
          }, null, 8, ["label", "placeholder", "value"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFlightOrigins.value, (group) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "px-2",
              key: group.key
            }, [
              (group.showTitle && group.codes && group.codes.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(group.type === 'train' ? content.value.flight_by_train : content.value.flight_by_plane), 1))
                : _createCommentVNode("", true),
              (group.name)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["mb-2 cursor-pointer option px-3 py-2", isSelected(group.key) && 'selected-option']),
                    onClick: () => handleSelect(group.key)
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                            _createElementVNode("use", {
                              "xlink:href": group.type === 'train'
													? '#___icon___train'
													: '#___icon___flight'
                            }, null, 8, _hoisted_11)
                          ]))
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(group.name), 1),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(group.codes.join(",")), 1)
                        ])
                      ]),
                      (isSelected(group.key))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _cache[1] || (_cache[1] = [
                            _createElementVNode("img", {
                              src: "https://www.uk.travelski.com/searchbox/img/svg/close.svg",
                              width: "18"
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_6))
                : _createCommentVNode("", true),
              (group.children)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(group.children, (child) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: child.key,
                      class: _normalizeClass(["ms-4 mb-2 cursor-pointer option px-3 py-2", isSelected(child.key) && 'selected-option']),
                      onClick: () => handleSelect(child.key)
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-primary me-2" }, [
                            _createElementVNode("svg", {
                              width: "20",
                              height: "20",
                              class: "icon text-primary-blue"
                            }, [
                              _createElementVNode("use", { "xlink:href": "#___icon___flight" })
                            ])
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_18, _toDisplayString(child.name), 1),
                            _createElementVNode("div", _hoisted_19, _toDisplayString(child.codes.join(",")), 1)
                          ])
                        ]),
                        (isSelected(child.key))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _cache[3] || (_cache[3] = [
                              _createElementVNode("img", {
                                src: "https://www.uk.travelski.com/searchbox/img/svg/close.svg",
                                width: "18"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_15))
                  }), 128))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (!filteredFlightOrigins.value.length && searchQuery.value.length >= 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(NoResultsSearch)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "noTransport",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event))
            }, null, 512), [
              [_vModelCheckbox, checked.value]
            ]),
            _createElementVNode("label", _hoisted_23, _toDisplayString(content.value.flight_switch_no), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "button-primary primary-normal p-2 mt-2 px-3 font-font-weight-600 font-size-16 cursor-pointer w-100 d-flex align-items-center justify-content-center py-3 py-md-2 px-4",
            onClick: handleConfirm,
            disabled: !selectedCode.value
          }, _toDisplayString(content.value.flight_confirm), 9, _hoisted_25)
        ])
      ]),
      _: 1
    }, 8, ["label", "placeholder", "value", "dropdownOpen", "disabled"])
  ], 2))
}
}

})